/**
 * plugins/index.ts - Plugin Auto-Discovery
 * 
 * PURPOSE:
 * - Import all plugins to trigger self-registration
 * - Single import point for apps
 * - Automatic plugin discovery
 * 
 * USAGE IN APPS:
 * ```typescript
 * import '@opcentral/pluggr/plugins';  // Triggers all registrations
 * import { getAvailablePlugins } from '@opcentral/pluggr';
 * 
 * const plugins = getAvailablePlugins();
 * ```
 */

// Import all plugins to trigger registration
import './list-manager';
import './filemaker';  // Imports all FileMaker plugins
import './translatr';  // Imports all Translatr plugins

// Mark registry as initialized
import { getPluginRegistry } from '../PluginRegistry';
getPluginRegistry().markInitialized();

console.log('[Pluggr] All plugins registered');
